import { PlantsCreateRequest, PlantsGetResponse, PlantUpdateCarryoverSlagSettingsRequest } from '.';
import { useApi } from '..';
import { PlantActivityResponse } from './PlantActivityResponse';
import { PlantUpdateRequest } from './PlantUpdateRequest';

export function usePlantsService() {
  const { get, post, put, patch } = useApi();
  const baseApi = `/v2/Plants`;

  const getAllPlants = async () => {
    const { data } = await get<PlantsGetResponse[]>(`${baseApi}`);

    return data;
  };

  const getPlantById = async (plantId: string) => {
    const { data } = await get<PlantsGetResponse>(`${baseApi}/${plantId}`);

    return data;
  }

  const getPlantActivitiesById = async (plantId: string) => {
    const { data } = await get<PlantActivityResponse[]>(`${baseApi}/${plantId}/activities`);

    return data;
  }

  const blockPlant = async (plantId: string, block: boolean, reason: string) => {
    const { data } = await patch<PlantsGetResponse>(`${baseApi}/${plantId}`, {block: block, Reason: reason});

    return data;
  }

  const createPlant = async (request: PlantsCreateRequest) => {
    const { data } = await post<PlantsGetResponse>(`${baseApi}`, request);

    return data;
  };

  const updatePlant = async (plantId: string, request: PlantUpdateRequest) => {
    const { data } = await put(`${baseApi}/${plantId}`, request);

    return data;
  }

  const updatePlantCarryoverSlagSettings = async (request: PlantUpdateCarryoverSlagSettingsRequest) => {
    const { data } = await put(`${baseApi}/CarryoverSlagSettings`, request);

    return data;
  };

  return {
    getAllPlants,
    createPlant,
    updatePlant,
    updatePlantCarryoverSlagSettings,
    getPlantById,
    blockPlant,
    getPlantActivitiesById,
  };
}
